import { ReactNode } from "react";
import { cn } from "../../lib/utils";

interface SectionHeadingProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const SectionHeading = ({
  title,
  subtitle,
  actions,
  className,
  size = "md",
}: SectionHeadingProps) => {
  const sizeClasses = {
    sm: {
      title: "text-lg font-semibold tracking-tight",
      subtitle: "text-sm text-muted-foreground",
    },
    md: {
      title: "text-xl font-semibold tracking-tight",
      subtitle: "text-sm text-muted-foreground",
    },
    lg: {
      title: "text-2xl font-bold tracking-tight",
      subtitle: "text-base text-muted-foreground",
    },
  };

  const currentSize = sizeClasses[size];

  return (
    <div
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
        className
      )}
    >
      <div className="space-y-1">
        <h2 className={currentSize.title}>{title}</h2>
        {subtitle && <p className={currentSize.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className="flex-shrink-0">{actions}</div>}
    </div>
  );
};
